// Library methods
import { useTranslation } from "react-i18next";
import useMediaQuery from "@mui/material/useMediaQuery";

// Components
import Box from "@mui/material/Box";
import DefaultModal from "../DefaultModal";

// Styles
import { useTheme } from "@mui/material/styles";

const ExpandDevicesModal = ({ open, onClose, children }) => {
  // modal fullScreen on small screens
  const { t } = useTranslation();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <DefaultModal
      isOpen={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="sm"
      title={t("devices_title")}
    >
      <Box padding="20px">{children}</Box>
    </DefaultModal>
  );
};

export default ExpandDevicesModal;
